import { mapState } from 'vuex'
export default {
  data() {
    return {
      clearAllLoading: false,
      deleteNotificationLoading: {}
    }
  },
  computed: {
    ...mapState({
      notifications: state => state.activities.notification.notifications,
      messageBadges: state => state.player.messageBadges
    })
  },
  methods: {
    getTitle(label) {
      if (label === 1) return this.tl('missions')
      if (label === 2) return this.tl('activities')
      if (label === 3 || label === 4) return this.tl('vip')
      return ''
    },
    timeAgo(createAt) {
      const now = this.$dayjs() // Current time
      const created = this.$dayjs(createAt)

      const diffInSeconds = now.diff(created, 'second')

      if (diffInSeconds < 60) {
        return `${diffInSeconds}${this.tl('s')}`
      }

      const diffInMinutes = now.diff(created, 'minute')
      if (diffInMinutes < 60) {
        return `${diffInMinutes}${this.tl('m')}`
      }

      const diffInHours = now.diff(created, 'hour')
      if (diffInHours < 24) {
        return `${diffInHours}${this.tl('h')}`
      }

      const diffInDays = now.diff(created, 'day')
      return `${diffInDays}${this.tl('d')}`
    },
    async onClearAllNotification() {
      if (this.clearAllLoading) return
      this.clearAllLoading = true
      await this.$store.dispatch('activities/notification/clearAllNotifications')
      this.clearAllLoading = false
    },
    onClickNotificationHandler(item) {
      if (item.label !== 2) {
        // To remove the notification from the list by frontend
        this.$store.dispatch('activities/notification/onDeleteNotificationList', item._id)
        // To view the notification, and remove by backend
        this.$store.dispatch('activities/notification/onViewNotification', item._id)
      }
      if (item.label === 1) {
        this.$router.push(
          `/activities/missions?mission_type=${item.mission_type || 1}&mission_id=${
            item.mission_id
          }&activity_id=${item.activity_id}`
        )
      } else if (item.label === 2) {
        this.$router.push(
          `/activities/missions?mission_type=${item.mission_type || 1}&mission_id=${
            item.mission_id
          }&activity_id=${item.activity_id}`
        )
      } else {
        this.$router.push(
          this.$config?.THEME === 'theme-4' ? '/player/vip' : `/player/profile?tab=1`
        )
      }
      this.$emit('close')
    },
    async onDeleteNotificationHandler(item) {
      this.deleteNotificationLoading = {
        ...this.deleteNotificationLoading,
        [item._id]: true
      }
      await this.$store.dispatch('activities/notification/deleteNotification', item._id)
      this.deleteNotificationLoading[item._id] = false
    },

    onClickHandlerRedirect() {
      this.$emit('close')
      this.$router.push('/player/messages')
    }
  }
}
